import React, {useEffect} from "react";
import { Alert, Container, Row } from "react-bootstrap";
import { useStoreActions } from 'easy-peasy';
import Loader from "../../../components/widgets/Loader";
import useCustomGetStoreState from "../../../hooks/useCustomGetStoreState";
import ParcelTableComponent from "../../../components/orders/preparatoryOrders/ParcelTableComponent";

const ParcelsList = () => {
    const {allParcels, isFetchingAllParcels} = useCustomGetStoreState('orders');
    const { fetchParcels } = useStoreActions(actions => actions.orders);
    useEffect(() => {
        fetchParcels();
    }, []);

    return <Container fluid>
        <Row>
            {isFetchingAllParcels && <Loader />}
            {allParcels?.length > 0 && <ParcelTableComponent parcels={allParcels} withParams={true} />}
            {allParcels?.length === 0 && !isFetchingAllParcels && <Alert variant="warning">Aucun colis n'a été trouvé</Alert>}
        </Row>
        </Container>
}

export default ParcelsList;